import sortBy from "lodash/sortBy"
import filter from "lodash/filter"
import get from "lodash/get"
import {
  READ_LIST,
  READ_LIST_SUCCEEDED,
  READ_LIST_FAILED,
  UPDATE_LIST,
  UPDATE_LIST_SUCCEEDED,
  UPDATE_LIST_FAILED,
  REMOVE_LIST_ITEM,
  REMOVE_LIST_ITEM_SUCCEEDED,
  REMOVE_LIST_ITEM_FAILED,
} from "../actions/types"

export const INITIAL_STATE = {}

export default function listReducer(state = INITIAL_STATE, action) {
  const name = action.config && action.config.name

  // reading - проп для ожидания перезаписывания списка в сторе
  if (action.type === READ_LIST) {
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: true,
        error: null,
        reading: true,
      },
    }
  }

  if (action.type === READ_LIST_SUCCEEDED) {
    return {
      ...state,
      [name]: {
        ...state[name],
        data: action.response.data,
        loading: false,
        error: null,
        reading: false,
        outerData: action.config.outerData
          ? action.config.outerData.data
          : null,
      },
    }
  }

  if (action.type === READ_LIST_FAILED) {
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: false,
        reading: false,
        error: action.error,
      },
    }
  }

  if (action.type === UPDATE_LIST) {
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: true,
        reading: false,
        error: null,
      },
    }
  }

  if (action.type === UPDATE_LIST_SUCCEEDED) {
    const item = action.config && action.config.item
    // TODO: remove this crutch after back fix!
    const isRemove = action.config && action.config.updateType === `delete`
    const listData = get(state, `${name}.data`, [])
    const sortNewList =
      item &&
      listData &&
      sortBy(
        isRemove
          ? listData.filter(resource => resource.uuid !== item.uuid)
          : listData.concat(item),
        item => item.name,
      )
    return {
      ...state,
      [name]: {
        ...state[name],
        data: item ? sortNewList : listData.concat(action.config.id),
        loading: false,
        reading: false,
        error: null,
      },
    }
  }

  if (action.type === UPDATE_LIST_FAILED) {
    const name = get(action, `action.config.name`, ``)
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: false,
        reading: false,
        error: action.error,
      },
    }
  }

  if (action.type === REMOVE_LIST_ITEM) {
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: true,
        reading: false,
        error: null,
      },
    }
  }

  if (action.type === REMOVE_LIST_ITEM_SUCCEEDED) {
    const listData = get(state, `${name}.data`, [])
    const removeId = get(action, `config.id`, null)
    const newList =
      listData &&
      filter(listData, item =>
        // item.id - для planner сервиса, item (содержит только uuid шаблона) - для report generator
        item.id ? item.id !== removeId : item !== removeId,
      )
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: false,
        error: null,
        reading: false,
        data: newList,
      },
    }
  }

  if (action.type === REMOVE_LIST_ITEM_FAILED) {
    const name = get(action, `action.config.name`, null)
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: false,
        reading: false,
        error: action.error,
      },
    }
  }
  return state
}
